export const getLoadingMessage = (isModal) => {
  const regularLoadingMsg = `Loading Quick LMI Calculator`;
  const modalLoadingMsg = `Loading LMI Calculator, please wait a few seconds`;
  return isModal ? modalLoadingMsg : regularLoadingMsg;
};
